export default class PlayerUtil {
  static isInPipMode() {
    const el = document.querySelector('#article-player');

    if (el == null) {
      return false;
    }

    return el.classList.contains('video-pip');
  }
}